// @flow
import { combineReducers } from 'redux';

import { dog } from './dog';
import { dogs } from './dogs';
import { owner } from './owner';
import { requests } from './requests';
import { vaccines } from './vaccines';
import { wagTag } from './wagTag';

export const rootReducer = combineReducers({
  dog,
  dogs,
  owner,
  requests,
  vaccines,
  wagTag,
});
